<template>
	<li>
		<a v-if="href" :href="prefix + href" class="Header-link" :class="{ 'Header-link--button': button, active: active }" tabindex="0"
			><slot></slot
		></a>
		<button v-else-if="code" class="Header-link" tabindex="0" @click="$emit('click', code)"><slot></slot></button>
		<span v-else class="Header-item"><slot></slot></span>
	</li>
</template>

<script>
export default {
	name: 'CloHeaderListItem',
	emits: ['click'],
	data() {
		return {};
	},
	props: {
		href: String,
		button: Boolean,
		active: Boolean,
		code: String,
		prefix: {
			type: String,
			default: '',
		},
	},
	computed: {},
};
</script>
